import { useContext, useEffect } from 'react';
import { isAfter, isBefore, isSameDay } from 'date-fns';

import { AsyncDataContext } from '@hh.ru/magritte-ui-date-picker/AsyncDataContext';
import { DateType } from '@hh.ru/magritte-ui-date-picker/types';

export const useDisabledDatesFunc = (
    startDate: DateType,
    endDate: DateType,
    disabledDates?: DateType[],
    minDate?: DateType,
    maxDate?: DateType
): ((date: DateType) => boolean) => {
    const asyncDataContext = useContext(AsyncDataContext);

    useEffect(() => {
        if (asyncDataContext !== null && !asyncDataContext.hasData(startDate, endDate)) {
            asyncDataContext.startAsyncLoading(startDate, endDate);
        }
    }, [asyncDataContext, startDate, endDate]);

    return (date) =>
        (disabledDates !== undefined && disabledDates.some((disabledDate) => isSameDay(disabledDate, date))) ||
        (asyncDataContext !== null &&
            asyncDataContext.disabledDates.some((disabledDate) => isSameDay(disabledDate, date))) ||
        (minDate !== undefined && isBefore(date, minDate)) ||
        (maxDate !== undefined && isAfter(date, maxDate));
};
